<!-- Footer -->
<section id="footer">
    <div class="container">
        <div class="row text-center text-xs-center text-sm-left text-md-left">
            <div class="col-xs-12 col-sm-4 col-md-4">
                <h5>Ubicación</h5>
                <div class="footer-text">
                    Calle Los Lirios #96 (Barrio Sirari, zona Equipetrol)
                </div>
            </div>
            <div class="col-xs-12 col-s -4 col-md-4">
                <h5><a [routerLink]="['/pacientes']">Soy Paciente</a></h5>
                <ul class="list-unstyled quick-links">
                    <li><a href="/pacientes#como-funciona"><i class="fa fa-angle-double-right"></i>¿Cómo funciona el
                            tratamiento?</a></li>
                    <li><a href="/pacientes#diferencias-paciente"><i class="fa fa-angle-double-right"></i>¿Cuáles son las
                            diferencias?</a></li>
                    <li><a href="/pacientes#encontrar-doctor"><i class="fa fa-angle-double-right"></i>Encuentre a su doctor</a>
                    </li>
                </ul>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <h5><a [routerLink]="['/ortodoncistas']">Soy Ortodoncista</a></h5>
                <ul class="list-unstyled quick-links">
                    <li><a href="/ortodoncistas#empresa"><i class="fa fa-angle-double-right"></i>Nuestra historia</a></li>
                    <li><a href="/ortodoncistas#diferencias"><i class="fa fa-angle-double-right"></i>Beneficios y
                            diferencias</a></li>
                    <li><a href="/ortodoncistas#acreditacion"><i class="fa fa-angle-double-right"></i>Acreditación</a></li>
                    <li><a href="/ortodoncistas#enviar-caso"><i class="fa fa-angle-double-right"></i>Envíe su caso</a></li>
                    <li><a [routerLink]="['/login']"><i class="fa fa-angle-double-right"></i>Acceso Ortodoncista</a></li>
                </ul>
            </div>
        </div>
        <div class="row">
            <hr />
        </div>
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 mt-2 mt-sm-2 text-center text-white">
                <p class="h6">&copy; BeAlign</p>
            </div>
            <hr />
        </div>
    </div>
</section>
<!-- ./Footer -->